// eslint-disable-next-line ts/ban-ts-comment
// @ts-ignore cache issues
import type { Cache, Sandbox } from "polystore-cache"

import type { Database } from "~/classes/worker/Database"
import type { PortRouter } from "~/classes/worker/PortRouter"

import { GlobalComposable } from "~/classes/composable/GlobalComposable"

class Mocks extends GlobalComposable {
  database: Database | undefined
  cache: Cache | undefined
  sandbox: Sandbox | undefined
  ports: PortRouter | undefined
  cacheChannel: MessageChannel | undefined
  cachePort: MessagePort | undefined
  sandboxChannel: MessageChannel | undefined
  sandboxPort: MessagePort | undefined
  opfs: FileSystemDirectoryHandle | undefined

  email: string | undefined
  password: string | undefined

  override onDestroy = () => {
    this.database = undefined
    this.cache = undefined
    this.sandbox = undefined
    this.ports = undefined
    this.cacheChannel = undefined
    this.cachePort = undefined
    this.sandboxChannel = undefined
    this.sandboxPort = undefined
    this.opfs = undefined
  }
}

const mocks = new Mocks("mocks")
export default function () {
  return mocks.use()
}
